import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({ selector: '[qaInfiniteScroll]' })
export class InfiniteScrollDirective {
  @Output() nearEnd: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('scroll', ['$event'])
  onScroll(event) {
    const tracker = event.target;
    const limit = tracker.scrollHeight - tracker.clientHeight;
    if (Math.ceil(limit - event.target.scrollTop) < 100) {
      this.nearEnd.emit();
    }
  }
}
